import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterList, beforeList } from '../../data/content';
import { CtaBlock } from '../CtaBlock';
export function BeforeAfter() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-98" data-mp="26lurs7sm6u9t">
      <div className="mx-auto max-w-4xl" data-id="element-99" data-mp="26k04imtveq2k">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand-dark" data-id="element-100" data-mp="22lkcu5mugtit">Il cambiamento</p>
        <h2 className="mt-3 text-center font-display text-[26px] font-bold leading-tight text-navy sm:text-4xl" data-id="element-101" data-mp="2z9qo3be9uk62">
          Smetti di improvvisare ogni pianificazione
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-navy/70" data-id="element-102" data-mp="2q9kbdrqedo7y">
          Segui un sistema clinico strutturato progettato per aiutarti a prendere decisioni migliori, dalla diagnosi
          fino alla finalizzazione del caso.
        </p>

        <div className="mt-9 grid gap-4 md:grid-cols-2 md:items-start" data-id="element-103" data-mp="19wdcr27qrvvg">
          <div className="rounded-3xl border border-navy/10 bg-white p-5 sm:p-6" data-id="element-104" data-mp="19y6notpe1299">
            <div className="flex items-center gap-2.5" data-id="element-105" data-mp="175vy11zzq5on">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#fdeceb]" data-id="element-106" data-mp="1c4yzydkobvse">
                <XIcon className="h-4 w-4 text-[#d4453f]" aria-hidden="true" data-id="element-107" data-mp="y57j852rw1ap" />
              </span>
              <h3 className="font-display text-lg font-bold text-navy sm:text-xl" data-id="element-108" data-mp="13396z3b58osi">Prima</h3>
            </div>
            <ul className="mt-4 space-y-2.5" data-id="element-109" data-mp="oemmyoakn8uy">
              {beforeList.map(item => <li key={item} className="flex items-start gap-2.5 text-[14px] leading-relaxed text-navy/70" data-id="element-110" data-mp="t5uufescck5h">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#d4453f]/70" aria-hidden="true" data-id="element-111" data-mp="ff7w3nqhsw9x" />
                  <span data-id="element-112" data-mp="jgte1nhvw0qz">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-3xl border-2 border-brand bg-white p-5 shadow-card sm:p-6" data-id="element-113" data-mp="5hblqy5dq5cv">
            <div className="flex items-center gap-2.5" data-id="element-114" data-mp="ae21fkd9uyxr">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-light" data-id="element-115" data-mp="2c499mkw9yxid">
                <CheckIcon className="h-4 w-4 text-brand-dark" aria-hidden="true" data-id="element-116" data-mp="27dke8uhh5gdy" />
              </span>
              <h3 className="font-display text-lg font-bold text-navy sm:text-xl" data-id="element-117" data-mp="23bph826ktp5z">Con il Sistema</h3>
            </div>
            <ul className="mt-4 space-y-2.5" data-id="element-118" data-mp="1ydnnmnbiy7g9">
              {afterList.map(item => <li key={item} className="flex items-start gap-2.5 text-[14px] font-medium leading-relaxed text-navy" data-id="element-119" data-mp="2v3n73ct7qqdm">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-120" data-mp="2r2l6osnk88a2" />
                  <span data-id="element-121" data-mp="2m1dxqq9ol31t">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <CtaBlock className="mt-9" label="Inizia a pianificare con un sistema" data-id="element-122" data-mp="2h2u9ukbj1h6t" />
      </div>
    </section>;
}